// extracted by mini-css-extract-plugin
export default {"root":"Popover-module_root__fna4D","open":"Popover-module_open__cxix9","content":"Popover-module_content__Y0ovv"};